import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementOrgTeamComponent } from './case-management-org-team.component';

const routes: Routes = [{ path: '', component: CaseManagementOrgTeamComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementOrgTeamRoutingModule { }
